import { render, staticRenderFns } from "./CarouselAdd.vue?vue&type=template&id=225b8207&scoped=true&"
import script from "./CarouselAdd.vue?vue&type=script&lang=js&"
export * from "./CarouselAdd.vue?vue&type=script&lang=js&"
import style0 from "./CarouselAdd.vue?vue&type=style&index=0&id=225b8207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225b8207",
  null
  
)

export default component.exports